var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._m(0),_c('router-view',{staticClass:"authContainer"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"alt":"MOK","src":require("../assets/img/Logo_MOK.webp")}})])
}]

export { render, staticRenderFns }